import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.page.html',
    styleUrls: ['./settings.page.scss'],
    standalone: false
})
export class SettingsPage implements OnInit {

    constructor(
        private router: Router,
        public global: GlobalService,
        public app: AppComponent,
    ) { }

    ngOnInit() {
        // this.optHideScanBtn = this.global.optHideScanBtn;
    }

    visiblePages(pagelist) {
        const pgs = [];
        for (const pg of pagelist) {
            if (!pg.hide && pg.url!=='/login') {
                pgs.push(pg);
            }
        }
        return pgs;
    }

    chHideScanBtn() {
        if (this.global.optHideScanBtn) {
            localStorage.setItem('hideScanBtn', '1');
        } else {
            localStorage.setItem('hideScanBtn', '0');
        }
    }

    chBTW() {
        if (this.global.optInclBtw) {
            localStorage.setItem('inclBTW', '1');
        } else {
            localStorage.setItem('inclBTW', '0');
        }
    }

    chPage() {
        localStorage.setItem('start', this.global.startPage);
    }

}
